var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('p',{staticClass:"help-block"},[_vm._v(" "+_vm._s(_vm.$t('Bareme.etape2.resultat.infoBaremeH', {anneePlus1: _vm.calculerAnneePlus1(), annee: _vm.dossier.periodeFiscale}))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }